import type { PersistenceLevel } from '@/core/flux.service';
import { Store } from '@/core/flux.service';
import type { HierarchyOutputV1 } from '@/sdk/model/HierarchyOutputV1';
import { hierarchyOutputToHierarchyInput } from '@/tableDefinitionEditor/assetBuilder.utilities';
import type { HierarchyInputV1 } from '@/sdk/model/HierarchyInputV1';

export class AssetBuilderStore extends Store {
  persistenceLevel: PersistenceLevel = 'NONE';
  static readonly storeName = 'sqAssetBuilderStore';

  initialize() {
    this.state = this.immutable({
      id: undefined,
      name: '',
      description: undefined,
      aliasColumnId: '',
      hierarchyOutput: undefined,
      selectedTreeOption: undefined,
    });
  }

  get id(): string | undefined {
    return this.state.get('id');
  }
  get name(): string {
    return this.state.get('name');
  }
  get description(): string | undefined {
    return this.state.get('description');
  }
  get aliasColumnId(): string {
    return this.state.get('aliasColumnId');
  }

  get hierarchyOutput(): HierarchyOutputV1 | undefined {
    return this.state.get('hierarchyOutput');
  }

  setName = ({ name }: { name: string }) => {
    this.state.set('name', name);
  };
  setDescription = ({ description }: { description: string | undefined }) => {
    this.state.set('description', description);
  };
  setAliasColumnId = ({ aliasColumnId }: { aliasColumnId: string }) => {
    this.state.set('aliasColumnId', aliasColumnId);
  };
  setHierarchyOutput = ({ hierarchyOutput }: { hierarchyOutput: HierarchyOutputV1 }) => {
    const hierarchyInput = hierarchyOutputToHierarchyInput(hierarchyOutput);
    const keys = Object.keys(hierarchyInput) as (keyof HierarchyInputV1)[];
    keys.forEach((key) => {
      this.state.set(key, hierarchyInput[key]);
    });
    this.state.set('id', hierarchyOutput.id);
    this.state.set('hierarchyOutput', hierarchyOutput);
  };

  reset = () => {
    this.initialize();
  };

  handlers = {
    ASSET_BUILDER_SET_NAME: this.setName,
    ASSET_BUILDER_SET_DESCRIPTION: this.setDescription,
    ASSET_BUILDER_SET_ALIAS_COLUMN_ID: this.setAliasColumnId,
    ASSET_BUILDER_SET_HIERARCHY_OUTPUT: this.setHierarchyOutput,
    ASSET_BUILDER_RESET: this.reset,
  };
}
